<template>
  <section class="navber">
    <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top">
      <a class="navbar-brand" href="/">
        <img class="logo" src="/assets/exported/logo.png" />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span aria-expanded="false" class="navbar-toggler-icon"></span>
        <span
          class="collapse navber-toggler-close"
          id="navbarSupportedContent"
          aria-hidden="true"
        >&times;</span>
      </button>

      <div class="collapse navbar-collapse" text="Dropdown Button" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item" @click="$root.hideSearch = true">
            <router-link
              to="/"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
              active-class="active border_nav"
              exact
              class="nav-link"
            >{{ $root.training.text }}</router-link>
          </li>
          <li class="nav-item" @click="$root.hideSearch = true">
            <router-link
              to="/course_list"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
              active-class="active border_nav"
              exact
              class="nav-link"
            >{{ $root.Courses.text }}</router-link>
          </li>
          <li class="nav-item" @click="$root.hideSearch = true">
            <router-link
              to="/my_learning"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
              active-class="active border_nav"
              exact
              class="nav-link"
            >{{ $root.Mycourse.text }}</router-link>
          </li>
          <!--<li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Dropdown
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item" href="#">Action</a>
          <a class="dropdown-item" href="#">Another action</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="#">Something else here</a>
        </div>
          </li>-->
        </ul>
        <form class="form-inline my-2 my-lg-0">
          <div class="input-group md-form form-sm form-1 pl-0">
            <div class="search_body">
              <span class="input-group-text purple lighten-3" id="basic-text1">
                <i class="fas fa-search text-white" aria-hidden="true"></i>
              </span>
            </div>
            <!--  v-on:blur="$root.hideSearch = true" -->
            <!-- v-on:focus="searchFocus()"  v-on:blur="$root.hideSearch = true;"-->
            <input
              v-model="query"
              v-on:click="searchFocus()"
              v-on:input="searchFocus()"
             
              class="form-control my-0 py-1"
              type="text"
              :placeholder="$root.search.place"
              aria-label="Search"
            />
          </div>
          <ul class="navbar-nav mr-auto header-btns" style="">
            <li
              v-if="$root.user_profile.data == null"
              class="nav_left_head active"
              @click="$root.hideSearch = true"
            >
              <router-link
                class="nav-link btn-1"
                to="/login"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                {{
                $root.login.text
                }}
              </router-link>
            </li>
            <li
              v-if="$root.user_profile.data == null"
              class="nav_left_head"
              @click="$root.hideSearch = true"
            >
              <router-link
                class="nav-link btn-2 nav-link1"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                to="/registration"
              >
                {{
                $root.ragistration.text
                }}
              </router-link>
            </li>

            <li
              @click="$root.hideSearch = true"
              v-if="$root.user_profile.data != null"
              class="dropdown mr-auto user_profile_icon"
            >
              <a class="nav-link btn-4" style="color: #000;cursor: pointer;">
                <i class="fa fa-user" aria-hidden="true"></i>
                <span style="font-size: 16px;margin-left: 10px;">{{ $root.user_profile.data.name}}</span>
              </a>
              <div class="dropdown-content" @click="$root.hideSearch = true">
                <router-link
                  to="/edit_profile"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  active-class="active"
                  exact
                >Update Profile</router-link>
                <a @click="$root.logout()" style="cursor:pointer;">Logout</a>
              </div>
            </li>

            <!--<li class="nav_left_head">
              <a class="nav-link btn-3"  >{{
                $root.language.text
              }}</a>
            </li>-->
          </ul>
        </form>
      </div>
    </nav>
    <div v-if="!$root.hideSearch == true">
      <search ref="search" />
    </div>
  </section>
</template>
<script src="./js/active.js"></script>
<script>
import axios from "axios";
import Search from "../components/search";
export default {
  name: "navber",
  components: {
    search: Search,
  },
  data() {
    return {
      inited: false,
      query: "",
      content: [],
      search: "",
    };
  },
  watch: {
    search: function (val) {
      if (!val) {
        this.result = [];
      }
    },
  },
  mounted() {
    $(".js-scroll-trigged").click(function () {
      $(".navbar-collapse").collapse("hide");
    });
  },
  beforeDestroy() {},
  methods: {
    searchFocus() {
      if(this.query == ""){return false;}
      window.scrollTo(0, 0);
      this.$root.hideSearch = false;
      this.searchQ();
    },

    searchQ() {
      if (this.query.length == 0) {
        return;
      }
      if (this.$router.currentRoute.path != "/search") {
        this.$router.push("/search");
      }
      var url =
        this.$root.API_BASE_URL + "search-course?search_key=" + this.query;
      var config = {
        headers: {
          "X-localization": this.$root.translate ? "bn" : "en",
        },
      };
      axios.get(url, config).then((response) => {
        this.$refs.search.query = this.query;
        this.$refs.search.content = [];
        this.$refs.search.content = response.data.data;
      });
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar-light .navbar-nav .nav-link1:focus,
.navbar-light .navbar-nav .nav-link1:hover {
  color: #fff !important;
}
.input-group {
  z-index: 1011;
}
.header-btns{
  margin-top: -5px;
}
.dropdown-content {
  z-index: 1013;
}
.fa-user {
  border-radius: 50px;
  border: 1.4px solid #005a06;
  padding: 9px;
  margin-top: 3px;
}
.fa-user:before {
  content: "\f007";
  color: #005a06;
}
.navbar img {
  position: absolute;
  width: 70px;
  margin-top: -35px;
  margin-left: 0px;
}
.border_nav {
  border-bottom: 4px solid #005a06;
  padding-bottom: 26px;
  /* margin-top: 22px; */
  position: relative;
  padding-top: 8px;
  margin-bottom: -30px;
}
.navber-toggler-close {
  font-size: 42px;
  position: absolute;
  margin-top: -15px;
  margin-left: -26px;
  background: #fff;
  padding: 5px 5px;
}
.navbar-collapse {
  margin-left: 60px;
}
.dropbtn {
  background-color: #4caf50;
  color: white;
  padding: 16px;
  font-size: 16px;
  border: none;
}

.dropdown {
  position: relative;
  display: inline-block;
  padding: 0px 20px;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #fff;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1013;
  margin-left: 10px;
  border-radius: 4px;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  font-weight: 600;
  margin-top: 7.5px;
}

.dropdown-content a:hover {
  background: transparent linear-gradient(264deg, #65ab1a 0%, #005a06 100%) 0%
    0% no-repeat padding-box;
  color: #fff;
  border-radius: 2px;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover .dropbtn {
  background-color: #3e8e41;
}
.user_profile_icon svg {
  width: 38px;
  color: #005a06;
  font-weight: 500;
  padding: 5px;
}
.navber .nav-link {
  font-size: 15px;
  font-weight: 600;
  margin-top: 5px;
}
.navber .nav-item {
  /* padding-left: 40px; */
  padding: 30px;
  margin-left: 0px;
}
.navber .navbar-nav {
  margin-left: 15px;
}
.navber .nav_left_head {
  padding-left: 10px;
}
.navber .btn-1 {
  margin-left: 1px;
  font-size: 14px;
}
.navber .btn-2 {
  width: 120px;
  margin-left: -10px;
}
.navber .btn-3 {
  margin-left: -10px;
  cursor: pointer;
}
.navber .btn-2,
.navber .btn-3 {
  color: #fff;
  font-size: 14px;
}
.navber .btn-2:hover,
.navber .btn-3:hover {
  color: #fff;
}
.navber .form-control {
  font-size: 14px;
  font-weight: 600;
  opacity: 0.6;
  border: 1px solid #fff0;
  margin-left: -8px;
  height: 29px;
}
.text-white {
  color: #495057 !important;
}
.input-group-text {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.475rem 0.5rem;
  margin-bottom: 0;
  font-size: 0.7rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #fff;
  border: 1px solid #fff0;
  border-radius: 0.25rem;
}
.input-group {
  border: 1px solid #d6d6d6;
  border-radius: 6px;
  height: 30px;
  margin-top: 4px;
  width: 220px;
}
.navber .mt-2,
.my-2 {
  margin-top: 0rem !important;
}
.navbar-brand {
  margin-left: 15px;
}
.footer-newsletter-content h2 {
  color: #000000;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 60px;
  margin-bottom: 10px;
}
.input-group-text {
  background-color: #fff0;
}

@media screen and (max-width: 1200px) {
  .navber .nav_left_head {
    padding-left: 20px;
    /* padding: 1px; */
  }
}
@media screen and (max-width: 1100px) {
  .navber .nav-item {
    padding: 20px;
    margin-left: 0px;
  }
}
@media screen and (max-width: 990px) {
   .navbar-collapse {
    background: #fff;
    width: 100%;
    margin-left: -20px;
    margin-right: -20px;
    margin-top: 4px;
    padding-bottom: 40px;
    box-shadow: -1px 4px 2px 0px #00000038;
    padding-top: 15px;
    position: relative;
  }
  .dropdown{
    display: inline-block;
    padding: 0px 20px;
    position: absolute;
    left: 30px;
    margin-top: -35px;
  }
  .header-btns{
     display: -webkit-box;
    display: -ms-flexbox;
    display: inline-block;
    -webkit-box-align: none;
    -ms-flex-align:none;
    align-items: none;
    -webkit-box-pack: none;
    -ms-flex-pack: none;
    justify-content: none;
  }
  .fixed-top {
    height: 80px;
    margin-top: -2px;
  }
  .navbar-toggler {
    margin-top: -14px;
  }
  .navbar img {
    position: relative;
    width: 60px;
    margin-top: -10px;
    margin-left: -5px;
  }
  .navber .nav-item {
    padding-left: 40px;
    padding: 0;
    margin-left: 40px;
    margin-top: 2px;
  }
  .fa-user {
    border-radius: 50%;
    border: 1.4px solid #005a06;
    padding: 9px;
    margin-top: 8px;
    margin-bottom: 3px;
    margin-left: 6px;
    height: 35px;
  }
  .navber .navbar-nav {
    margin-left: -6px;
  }
  .navber .btn-1{
    margin-top: -35px;
    margin-left: 0px;
  }
  .navber .btn-2{
    width: auto; 
    margin-left: 0px;
  }
 
  .dropdown:hover .dropdown-content {
    margin-bottom: -50px;
    margin-top: -20px;
    margin-left: -15px;
  }
  .btn-4 {
    margin-top: 10px;
  }
  .border_nav {
    border-bottom: 0px solid #005a06;
    padding-bottom: 22px;
    position: relative;
    padding-top: 8px;
    margin-bottom: 0px;
    background: transparent linear-gradient(264deg, #65ab1a 0%, #005a06 100%) 0%
    0% no-repeat padding-box;
    margin-left: -30px;
    padding: 10px 30px;
    color: #fff !important;
  }
  .form-inline {
    margin-left: 35px;
  }
  .input-group {
    width: 55%;
  }
  .navber .nav_left_head {
    padding-left: 25px;
    padding: 1px 25px;
    position: relative;
    display: flex;
  }
 
  .navbar-nav {
    margin-left: -15px;
    padding-bottom: 90px;
  }
  .navber .nav_left_head {
    margin-left: 10px;
    margin-bottom: 7px;
    position: relative;
    display: block;
    position: absolute;
    left: 0;
  }
  
  .header-btns{
    margin-left: 160px;
    float: left;
    margin-top: -50px;
  }
  .btn-4 {
    margin-left: -22px;
    /* margin-top: 10px; */
    /* padding-top: 10px; */
    padding-bottom: 22px;
  }
}

@media screen and (max-width: 683px) {
  .input-group {
    width: 55%;
  }
}
.logo {
  width: 300px;
  height: auto;
  background-position: center top;
  padding: 0px;
  margin: 0 auto;
}
@media screen and (max-width: 600px) and (orientation: landscape)  {
.navber .nav-item{
    margin-top: -4px;
}
.navber .btn-1{
    margin-top: -38px;
}
.navber .btn-2{
    margin-top: -2px;
}
.input-group{
  margin-top: -5px;
}
}
@media only screen and (min-width: 20em) {
  .logo {
    background-position: center 300px;
  }
}
/* 328px */

@media only screen and (min-width: 48em) {
  .logo {
    background-position: left -300px;
    width: 600px;
    height: auto;
  }
}
/* 768px */

@media only screen and (min-width: 56.25em) {
  .logo {
    background-position: left 0px;
    width: 600px;
    height: auto;
  }
}
@media only screen and (min-width: 480px) and (max-width: 920px) and (orientation: landscape) {
  .navbar-collapse {
    background: #fff;
    width: 100%;
    margin-left: -20px;
    margin-right: -20px;
    margin-top: 4px;
    padding-bottom: 150px;
    -webkit-box-shadow: -1px 4px 2px 0px #00000038;
    box-shadow: -1px 4px 2px 0px #00000038;
  }
}
</style>
